export default __webpack_public_path__ + "c54309c3026741e7c0b632d77f19593c.jpg";